import React, { Fragment, Component } from 'react';
import { withFormik, Field } from 'formik';
import * as yup from 'yup';
import { TEXT_LINK, IMAGE_LINK } from 'helpers/constants';

import FieldInputComponent from 'components/FieldInputComponent';
import RadioBtnGroup from 'components/RadioBtnGroup';
import FieldUploadImage from 'components/FieldUploadImage';
import ButtonCustom from 'components/ButtonCustom';

const CreateNewSchema = yup.object().shape({
  variety: yup.string().required("Link type can't be empty"),

  image: yup.mixed().when('variety', {
    is: val => val === IMAGE_LINK,
    then: yup.mixed().required("Image link can't be empty"),
  }),

  create_link_name: yup
    .string()
    .min(2, 'Must be at least 2 characters')
    .when('variety', {
      is: val => val === TEXT_LINK,
      then: yup.string().required("Link name can't be empty"),
    }),

  create_link_url: yup
    .string()
    .url('Please input your site url')
    .required("URL can't be empty"),
});

class CreateNew extends Component {
  state = {
    isImageLoading: false,
  };

  spinnerStart = () => {
    this.setState({ isImageLoading: true });
  };

  spinnerStop = () => {
    this.setState({
      isImageLoading: false,
    });
  };

  handleSetImage = e => {
    this.spinnerStart();
    e.persist();
    const { setFieldValue } = this.props;
    setFieldValue('image', e.target.files[0]);
    this.spinnerStop();
  };

  handleChangeVariety = e => {
    const { setFieldValue } = this.props;
    let variety = e.target.value;

    setFieldValue('variety', variety);

    if (variety === TEXT_LINK) {
      setFieldValue('image', '');
    } else {
      setFieldValue('create_link_name', '');
    }
  };

  render() {
    const {
      values,
      touched,
      errors,
      dirty,
      handleSubmit,
      handleReset,
      isSubmitting,
      isValid,
    } = this.props;

    let linkInput;

    if (values.variety === TEXT_LINK) {
      linkInput = (
        <Field
          name="create_link_name"
          component={FieldInputComponent}
          error={touched.create_link_name && errors.create_link_name}
          id="create_link_name"
          type="text"
          label="New link name"
        />
      );
    } else {
      linkInput = (
        <div className="upload-img">
          <Field
            name="image"
            component={FieldUploadImage}
            error={touched.image && errors.image}
            idUploadInput="upload-link-img"
            isImageLoading={this.state.isImageLoading}
            inputClass="upload-img__input"
            labelClass="upload-img__label"
            helpText={
              values.image.name || 'Size up to 10MB. Formats: jpg, jpeg, png.'
            }
            setFiles={this.handleSetImage}
            label="Upload your image"
          />
        </div>
      );
    }

    return (
      <Fragment>
        <h2 className="h2-title">Create new</h2>
        <div className="separator-line" />
        <form className="content-form content-form--bg" onSubmit={handleSubmit}>
          <RadioBtnGroup
            textGroup="Select the type"
            value={values.variety}
            handleChange={this.handleChangeVariety}
          />
          <div className="separator-line" />
          <div className="form-row">
            <div className="form-col-12">{linkInput}</div>
          </div>
          <div className="form-row">
            <div className="form-col-12">
              <Field
                name="create_link_url"
                component={FieldInputComponent}
                error={touched.create_link_url && errors.create_link_url}
                id="create_link_url"
                type="text"
                label="Link URL:"
              />
            </div>
          </div>
          <div className="separator-line m-t-30" />
          <div className="content-form__btn">
            <ButtonCustom
              className="btn btn-blue big"
              type="submit"
              disabled={!isValid || isSubmitting}>
              Add link
            </ButtonCustom>
            <ButtonCustom
              className="btn btn-blue outline m-l-15 outline"
              type="button"
              onClick={handleReset}
              disabled={!dirty || isSubmitting}>
              Clear
            </ButtonCustom>
          </div>
        </form>
      </Fragment>
    );
  }
}

export default withFormik({
  mapPropsToValues: () => ({
    create_link_name: '',
    create_link_url: '',
    image: '',
    variety: TEXT_LINK,
  }),
  validationSchema: CreateNewSchema,
  handleSubmit: async (payload, { props, setSubmitting, resetForm }) => {
    await props.handleSubmit(payload);
    setSubmitting(false);
    resetForm();
  },
})(CreateNew);



// WEBPACK FOOTER //
// ./src/components/CreateNew/CreateNew.js